import { z } from 'zod';
// Tile coordinate schema
export const TileCoordinateSchema = z.object({
    x: z.number().int('X coordinate must be an integer'),
    y: z.number().int('Y coordinate must be an integer')
});
// Private area bounds schema
export const PrivateAreaBoundsSchema = z.object({
    minX: z.number(),
    maxX: z.number(),
    minY: z.number(),
    maxY: z.number()
});
// Private area occupant schema
export const PrivateAreaOccupantSchema = z.object({
    userId: z.string().uuid('Invalid user ID'),
    username: z.string().min(1, 'Username is required'),
    avatar: z.string().min(1, 'Avatar is required'),
    enteredAt: z.string().datetime('Invalid entry date')
});
// Private area data schema
export const PrivateAreaDataSchema = z.object({
    id: z.string().uuid('Invalid area ID'),
    roomId: z.string().uuid('Invalid room ID'),
    areaId: z.string().min(1, 'Area ID is required'),
    name: z.string().optional(),
    closed: z.boolean(),
    capacity: z.number().int('Capacity must be an integer').min(1, 'Capacity must be at least 1'),
    ownerId: z.string().uuid('Invalid owner ID').optional(),
    ownerUsername: z.string().optional(),
    ownerAvatar: z.string().optional(),
    bounds: z.object({
        tiles: z.array(TileCoordinateSchema).min(1, 'At least one tile is required'),
        worldBounds: PrivateAreaBoundsSchema.optional()
    }),
    occupants: z.array(PrivateAreaOccupantSchema),
    createdAt: z.string().datetime('Invalid creation date')
});
// Private area update request schema (for incoming WebSocket messages)
export const PrivateAreaUpdateRequestSchema = z.object({
    areaId: z.string().min(1, 'Area ID is required'),
    action: z.enum(['player_entered', 'player_left', 'closed', 'opened'], {
        errorMap: () => ({ message: 'Invalid action type' })
    }),
    userId: z.string().uuid('Invalid user ID').optional()
});
// Private area update schema (for WebSocket broadcast messages - includes area data)
export const PrivateAreaUpdateSchema = z.object({
    areaId: z.string().min(1, 'Area ID is required'),
    action: z.enum(['player_entered', 'player_left', 'closed', 'opened'], {
        errorMap: () => ({ message: 'Invalid action type' })
    }),
    userId: z.string().uuid('Invalid user ID').optional(),
    area: PrivateAreaDataSchema
});
// Server private area schema (for backend services)
export const ServerPrivateAreaSchema = PrivateAreaDataSchema;
